import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import PosBoxTable from '@pos/components/tables/pos-box-table/pos-box-table.vue';

@Component({
  name: 'bpc-pos-boxes',
  components: {
    'bpc-pos-box-table': PosBoxTable,
  },
})
export default class PosBoxes extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
